<template>
  <div class="stock-wrap" key="2">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <!-- 导出excel -->
        <el-form-item style="float: right; margin-right: 0" v-if="funcView.export_stock">
          <el-button class="table-set" style="vertical-align: top" @click="exportTable"><i class="icon icon-daochu"></i></el-button>
        </el-form-item>
        <el-form-item v-if="funcView.out_stock" :class="funcView.export_stock ? '' : 'mr-0'">
          <el-button type="primary" :disabled="!checkOutStock(tableSelect) || !tableSelect.length" @click="onSelectOutStock()">
            <i class="icon icon-transfer"></i>
            &ensp;{{ funcView.out_stock }}
          </el-button>
        </el-form-item>
        <el-form-item style="float: right">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <el-form-item style="float: right">
          <search-input :placeholder="$t('dms_stock_in.jshModemSNcpSNrkr')" v-model="formSearch.search" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="$refs.container"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
      <el-form :inline="true" label-position="top">
        <el-form-item :label="$t('dms_stock_in.ISTzhan_dian')">
          <custom-select
            @change="websiteNameChange"
            v-model="formSearch.websiteName"
            filterable
            url="websiteSelectList"
            :params="{ websiteEnv: this.websiteEnv, websiteType: 1 }"
            :model="formSearch"
            :props="{ label: 'websiteName', value: 'websiteName', map: { websiteCode: 'websiteCode' } }"
            width="100%"
          ></custom-select>
        </el-form-item>
        <el-form-item :label="$t('dms_stock_in.chan_pin_xing_hao')">
          <custom-select
            url="productCodeSelectList"
            v-model="formSearch.productCode"
            :listener="formSearch.websiteCode"
            :props="{ label: 'productCode', value: 'productCode' }"
            :params="{ websiteCode: formSearch.websiteCode }"
            width="100%"
          ></custom-select>
        </el-form-item>
        <!-- 剩余电量 -->
        <el-form-item :label="$t('dms_stock_in.sheng_yu_dian_liang')">
          <input-range v-model="formSearch.batteryCharge" type="number" style="width: 100%" />
        </el-form-item>
        <el-form-item label="IMSI">
          <el-input v-model="formSearch.imsi"></el-input>
        </el-form-item>
        <!-- <el-form-item :label="$t('page_stock_zhan_dian_1')">
          <el-input v-model="formSearch.websiteName"></el-input>
        </el-form-item> -->
        <el-form-item :label="$t('dms_stock_in.xie_yi')">
          <el-input v-model="formSearch.protocolCode"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_stock_in.ru_ku_dan_hao')">
          <el-input v-model="formSearch.inBatchNum"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_stock_in.ru_ku_shi_jian')">
          <custom-date-picker
            style="width: 100%"
            v-model="formSearch.dataTimes"
            type="daterange"
            value-format="YYYY-MM-DD HH:mm:ss"
            :picker-options="beforeToday"
            :start-placeholder="$t('dms_stock_in.kai_shi_ri_qi')"
            :end-placeholder="$t('dms_stock_in.jie_shu_ri_qi')"
          ></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('dms_stock_in.ji_qi_ban_ben')">
          <el-input v-model="formSearch.machineVersion" placeholder="" style="width: 100%"></el-input>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table
        type="checkbox"
        v-model="tableSelect"
        height="100%"
        :index="true"
        :data="tableList"
        :slots="['modemSn', 'protocolCode', 'action', 'websiteName']"
        tableCode="factory_stock_in"
        @sort="sortChange"
        @filter="filterChange"
        @column="setColumn"
      >
        <template v-slot:websiteName="scope">{{ getWebsiteName(scope.row) }}</template>
        <template v-slot:protocolCode="scope">{{ scope.row.protocolCode || '-' }} / {{ scope.row.tcpVersion || '-' }}</template>
        <template slot="modemSn" slot-scope="scope">
          <div
            v-if="funcView.stock_modem_details"
            class="cell-link"
            @click="jump('/redirect/boarddetail', { deviceId: scope.row.deviceId, modemSn: scope.row.modemSn, type: 'entire', testType: formSearch.testType, parentPath: $route.path })"
          >
            {{ scope.row.modemSn }}
          </div>
          <span v-else>{{ scope.row.modemSn }}</span>
        </template>
        <template slot="action" slot-scope="scope">
          <span></span>
          <el-button v-if="checkOutStock(scope.row) && funcView.out_stock" type="text" size="mini" @click="onOutStock(scope.row)">{{ funcView.out_stock }}</el-button>
          <el-button v-if="funcView.stock_in_edit" type="text" size="mini" @click="onEdit(scope.row)">{{ $t('Common.com_edit') }}</el-button>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>

    <out-stock-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="getTableList"></out-stock-dialog>
    <!-- 编辑 -->
    <entireItem-dialog v-if="dialogVisible2" :model="dialogModel2" @close="dialogVisible2 = false" @success="getTableList"></entireItem-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import inputRange from '@/components/inputRange';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins';
import outStockDialog from '@/pages/dms/factoryStock/children/out_stock_dialog.vue';
import entireItemDialog from '@/pages/dms/factoryStock/children/entire_Item_dialog.vue';

export default {
  name: 'stockIn',
  mixins: [resetFormSearchMixins],
  components: {
    outStockDialog,
    inputRange,
    entireItemDialog,
  },
  props: {},
  data() {
    return {
      tableSelect: [],

      formSearch: {
        protocolCode: '',
        search: '',
        stockState: 2,
        orderBy: '',
        orderType: '',
        pageSize: 50,
        pageNum: 1,
        productCode: '',
        imsi: '',
        tcpVersion: '',
        batteryCharge: [],
        dataTimes: [],
        websiteName: '',
        inBatchNum: '',
        machineVersion: '',
      },
      tableList: [],
      totalRows: 0,
      dialogVisible: false,
      dialogModel: {},
      dialogVisible2: false,
      dialogModel2: {},

      // IST 站点列表
      istList: [],
    };
  },
  computed: {},
  watch: {},
  filters: {},
  directives: {},
  methods: {
    initIstList() {
      const reqUrl = apis.websiteSelectList;
      const reqData = { websiteEnv: this.websiteEnv, websiteType: 1 };
      this.$getJSON(reqUrl, reqData).then((res) => {
        this.istList = res.data || [];
      });
    },
    getWebsiteName(row) {
      const istList = this.istList;
      if (istList.length) {
        const item = istList.find((obj) => obj.websiteCode === row.websiteCode);
        if (item) {
          return item.websiteName;
        }
      }
      return row.websiteName || '-';
    },
    websiteNameChange() {
      this.formSearch.productCode = '';
    },
    // 判断是否有出库的权限
    // 这个状态等于2才有这个按钮
    checkOutStock(data) {
      const rows = Array.isArray(data) ? [...data] : [data];
      return !rows.some((item) => `${item.stockState}` !== '2');
    },
    // 获取列表
    getTableList() {
      this.formSearch.startTime = this.formSearch.dataTimes ? this.formSearch.dataTimes[0] : '';
      this.formSearch.endTime = this.formSearch.dataTimes ? this.formSearch.dataTimes[1] : '';
      this.formSearch.beginOfBatteryCharge = this.formSearch.batteryCharge ? this.formSearch.batteryCharge[0] : '';
      this.formSearch.endOfBatteryCharge = this.formSearch.batteryCharge ? this.formSearch.batteryCharge[1] : '';
      const reqData = {
        ...this.formSearch,
      };
      delete reqData.dataTimes;
      this.$getJSON(apis.FactoryStockPage, reqData).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    onOutStock: function (row) {
      this.dialogModel.title = this.$t('dms_stock_in.she_bei_chu_ku');
      this.dialogModel.rows = [row];
      this.dialogModel.countryCode = row.countryCode;
      this.dialogModel.websiteCode = row.websiteCode;
      this.dialogVisible = true;
    },
    onSelectOutStock: function () {
      this.dialogModel.title = this.$t('dms_stock_in.she_bei_chu_ku');
      this.dialogModel.rows = this.tableSelect;
      this.dialogModel.countryCode = this.tableSelect[0].countryCode;
      this.dialogModel.websiteCode = this.tableSelect[0].websiteCode;
      this.dialogVisible = true;
    },
    // 数据导出
    exportTable: function () {
      const reqData = {
        ...this.formSearch,
      };
      delete reqData.pageSize;
      delete reqData.pageNum;

      this.$exportFlie(apis.factoryStockExport, reqData);
    },
    // 编辑
    onEdit(row) {
      this.dialogModel2.title = this.$t('Common.com_edit');
      this.dialogModel2.type = 'edit';
      this.dialogModel2.data = row;
      this.dialogVisible2 = true;
    },
  },
  created() {},
  mounted() {
    this.initIstList();
    this.getTableList();
    this.getFuncView();
  },
};
</script>

<style lang="scss"></style>
